import React, { useRef } from 'react'
import styles from './styles.module.css'
import OptimizedImage from '../../../../OptimizedImage'

function ZoomableImage({ image, alt, sizes }) {
  const wrapperRef = useRef(null)

  const handleMouseMove = (e) => {
    const wrapper = wrapperRef.current
    if (!wrapper) return

    const img = wrapper.querySelector('img')
    if (!img) return

    const rect = wrapper.getBoundingClientRect()
    const xPercent = ((e.clientX - rect.left) / rect.width) * 100
    const yPercent = ((e.clientY - rect.top) / rect.height) * 100

    img.style.transformOrigin = `${xPercent}% ${yPercent}%`
  }

  const handleMouseLeave = () => {
    const wrapper = wrapperRef.current
    if (!wrapper) return

    const img = wrapper.querySelector('img')
    if (!img) return

    img.style.transformOrigin = 'center center'
  }

  return (
    <div
      className={styles.zoomableWrapper}
      ref={wrapperRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {/* Forward the FULL ResolvedImage descriptor (srcSet + dims + blur
          placeholder), not a bare src string — the bare-string path bypasses the
          #67/#129 resolver (no srcSet, no dims) and trips OptimizedImage's dev
          bare-src console.error (the #124 gate reds it). reserveSpace={false}: the
          parent .imageWrapper already owns the fixed 4/3 box, so the fill wrapper
          just fills it (matches the mobile Carousel). */}
      <OptimizedImage
        image={image}
        alt={alt || ''}
        layout="fill"
        sizes={sizes}
        reserveSpace={false}
      />
    </div>
  )
}

export default ZoomableImage
